module.exports = __webpack_public_path__ + "static/img/c3dd42e.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/xczx/img/dh.png
// module id = 260
// module chunks = 2